import {
  updateItemToFroomleRecommendation,
  updateItemToFroomleRecommendationScoped,
} from './froomle-item-helpers';

const msntItemSelector = '.item-4';

const msntSkeletonItemCls = 'item-4';
const msntSkeletonItemSelector = `.${msntSkeletonItemCls}`;

const msntRecommendationContainerSelector = '[data-recommendations="true"]';
const nonScopedBlocksItemSelectors = {};

export const config = {
  ...window.jsVars?.froomle,

  msntItemSelector,
  msntSkeletonItemSelector,
  msntSkeletonItemCls,
  msntRecommendationContainerSelector,

  nonScopedBlocksSelectors: {},
  nonScopedBlocksItemSelectors,

  scopedBlocksSelectors: {
  },
  scopedBlocksItemSelectors: {
  },

  hooks: {
  },

  user: {
    userId: localStorage.getItem('userId'),
    //todo if Editor
    isEditor: false,
  },
  updateItemToFroomleRecommendation,
  updateItemToFroomleRecommendationScoped,
};
